import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/ubuntu/500.css';
import '@fontsource/ubuntu/700.css';
import App from './App.jsx';
import './styles.css';
import './shopify-lockup.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider><BrowserRouter><App /></BrowserRouter></HelmetProvider>
  </React.StrictMode>,
);
